<template>
    <v-container>
        <div>
            <template>
                <v-dialog v-model="dialog" width="600" @click:outside="closeModal" :retain-focus="false">
                    <v-card class="custom-card" rounded="0">
                        <v-toolbar color="secondary" class="white--text">
                            <v-toolbar-title class="font-weight-bold">
                               {{ $t('noPrimaryFarmsAvailable') }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon class="white--text" @click="closeModal">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text class="black--text">
                            <v-row class="mt-5">
                                <v-col cols="12">
                                    <span>{{ $t('noPrimaryFarmsAvailableL2') }}</span>
                               </v-col>
                            </v-row>
                            <v-card-actions class="mt-10" style="padding-right: 0">
                                <v-spacer></v-spacer>
                                <v-btn @click="submit" right height="44" color="primary" class="px-5">
                                    {{ $t('okey') }}
                                </v-btn>
                            </v-card-actions>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </template>
        </div>
    </v-container>
</template>
  
<script>
import loadingMixin from "@/mixins/LoadingMixin";

export default {
    computed: {
        dialog() {
            return this.dialogI;
        },
    },
    data() {
        return {
            name: '',
        };
    },
    props: {
        dialogI: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        closeModal() {
            this.$emit("closeDialog");
        },
        submit() {
            this.$router.push('/myfarm/farmlist');
        }
    },
    mixins: [loadingMixin],
};
</script>
  
<style lang="scss" scoped>
.border {
    border: 2px solid;
    border-color: #dae1ec;
}

.v-tab {
    text-transform: none !important;
}
</style>
 